import React from 'react';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import BackButton from 'components/Button';
// import Image from './caminho/para/sua-imagem.jpg'; // Importe sua imagem aqui

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
        width: '60%',
        margin: 'auto',
    },
    section: {
        marginBottom: theme.spacing(4),
    },
    title: {
        marginBottom: theme.spacing(2),
        fontWeight: 'bold',
    },
    content: {
        marginBottom: theme.spacing(2),
    },
    imageColumn: {
        textAlign: 'center',
    },
    image: {
        maxWidth: '100%',
        height: 'auto',
    },
    backButton: {
        marginTop: theme.spacing(2),
        justifyContent: 'center',
        display: 'flex'
    },
}));

const ProgramadeResistencia = () => {
    const classes = useStyles();

    return (
        <Grid container className={classes.root}>
            <Grid item xs={12} className={classes.section}>
                <Typography variant="h4" className={classes.title}>
                    Boa Prática - Campos de Júlio/MT tem programa de resistência às drogas
                </Typography>
                <Typography variant="body1" className={classes.content}>
                    <strong>Data:</strong> Segunda, 07 de maio de 2012
                </Typography>
                <Typography variant="body1" className={classes.content}>
                    <strong>Município:</strong> Campos de Júlio/MT
                </Typography>
            </Grid>
            <Grid item xs={12} className={classes.section}>
                <Typography variant="h5" className={classes.title}>
                    Iniciativa da prefeitura
                </Typography>
                <Typography variant="body1" className={classes.content}>
                    A primeira boa ação de enfrentamento registrada no portal Observatório do Crack, lançado nesta terça-feira, 26 de abril, foi a de Campos de Júlio (MT). O Município desenvolve desde 2002 projeto de ação preventiva com os alunos da rede municipal e estadual. O trabalho foi viabilizado por meio de um termo de Cooperação Técnica e Logística entre o Programa Educacional de Resistência às Drogas e a Violência (Proerd) da Policia Militar e a secretaria de Educação, Em entrevista a Agência CNM de Notícias, a coordenadora da Secretaria de Educação, Nelsa Gouvêa Meleiro, contou que é como se fosse um curso ministrado uma vez por semana, incluído no currículo escolar, que orienta sobre os efeitos físicos e mentais causados pelo consumo de entorpecentes. E ao final do trabalho cada integrante da turma recebe um certificado de participação.
                    “Um integrante da polícia apto a desenvolver o trabalho de prevenção vai até a escola e desenvolve atividades com os alunos do quarto, quinto e sexto ano”, explicou Nelsa. O objetivo do programa é ampliar o nível de informação dos estudantes alcança os pais e o corpo docente.
                </Typography>
            </Grid>
            <Grid item xs={12} className={classes.section}>
                <Typography variant="h5" className={classes.title}>
                    Resultados
                </Typography>
                <Typography variant="body1" className={classes.content}>
                    - A maioria escolas do Município foi mobilizada.
                    - Atendimento de aproximadamente 1.100 crianças e adolescentes como beneficiários diretos.
                    - Uma parcela desse público tem atendimento em tempo integral, com oferta de alimentação, higienização pessoal e transporte.
                    - Diminuição do número de vítimas de exploração do trabalho infantil.
                    - Aumento do leque de oportunidade de emprego.
                    - Encaminhamento de adolescentes usuários de drogas a centros de tratamento.
                    - Ex-alunos são empregados no projeto.
                </Typography>
            </Grid>
            <Grid item xs={12} className={classes.section}>
                <Typography variant="h5" className={classes.title}>
                    Recursos
                </Typography>
                <Typography variant="body1" className={classes.content}>
                    A Funcef, bem como seus programas e projetos, é mantida pela Prefeitura Municipal de Formoso do Araguaia e por doações de empresas locais. Para somar, existem parcerias com as Secretarias de Saúde, Assistência social, Educação, Esporte, Lazer, Meio Ambiente e Turismo.
                    O valor anual para o desenvolvimento das atividades é de, aproximadamente, R$ 550 mil.
                </Typography>
            </Grid>
            <Grid item xs={12} className={classes.backButton}>
                <BackButton />
            </Grid>
        </Grid>
    );
};

export default ProgramadeResistencia;
